import Link from 'next/link'
import styled from 'styled-components'

const StyledArrowImg = styled.img`
  width: 26px;
`

export type ArchivedCookiePolicy = {
  url: string
  effectiveFrom: string
}

type ArchivedCookiePolicyListProps = {
  archivedCookiePolicy: ArchivedCookiePolicy[]
}

const getCookiePolicyDataTestId = (p: ArchivedCookiePolicy) =>
  `cp-archive-${(p.effectiveFrom || '').replace(/ /g, '-')}`

export const ArchivedCookiePolicyList = ({ archivedCookiePolicy = [] }: ArchivedCookiePolicyListProps) => {
  return (
    <>
      {archivedCookiePolicy.length === 0 ? (
        <p>No previous versions found</p>
      ) : (
        <ol>
          {archivedCookiePolicy.map((p) => (
            <li key={p.effectiveFrom} data-testid={getCookiePolicyDataTestId(p)}>
              <Link href={p.url} passHref>
                <span>{p.effectiveFrom}</span>
                <StyledArrowImg src="/assets/img/icons/link-arrow-blue.svg" alt="" />
              </Link>
            </li>
          ))}
        </ol>
      )}
    </>
  )
}
